import { useMemo } from 'react';

import { toBN } from '@utils/formaters.utils';

import { FarmCard } from '@app-types/vaults/farm.types';

interface UseTablesHeightProps {
  refSelectedFarms: null | number;
  refContent: null | number;
  selectedFarms: FarmCard[];
  isMaxFarmsCount: boolean;
  contentHeight: number;
}

interface UseTablesHeight {
  tableHeightAllFarms: number;
  tableHeightSelectedFarms: number;
}

const TABLE_SUB_HEADER = 60;

const GAP = 24;

const BUTTONS_HEIGHT = 44;

const SPACE_HEIGHT = BUTTONS_HEIGHT + GAP;

const TABLE_ROW_HEIGHT = 40;

const TABLE_HEADER_HEIGHT = 44;

const MAX_COUNT_TEXT_HEIGHT = 40;

const MAX_COUNT_HEIGHT = MAX_COUNT_TEXT_HEIGHT + GAP;

const useTablesHeight = ({
  refSelectedFarms,
  selectedFarms,
  isMaxFarmsCount,
  contentHeight,
}: UseTablesHeightProps): UseTablesHeight => {
  const tablesHeight = useMemo(
    () =>
      selectedFarms.length
        ? contentHeight - SPACE_HEIGHT - TABLE_SUB_HEADER
        : contentHeight - BUTTONS_HEIGHT - TABLE_SUB_HEADER,
    [contentHeight, selectedFarms],
  );

  const selectedFarmsTableHeight = useMemo(
    () => refSelectedFarms || 0,
    [refSelectedFarms],
  );

  const tableHeightAllFarms = useMemo(
    () => tablesHeight - selectedFarmsTableHeight - GAP,
    [tablesHeight, selectedFarmsTableHeight],
  );

  const tableHeightSelectedFarms = useMemo(() => {
    const height = `${toBN(selectedFarms.length)
      .times(TABLE_ROW_HEIGHT)
      .plus(TABLE_HEADER_HEIGHT)}`;

    const isMaxHeight = isMaxFarmsCount ? MAX_COUNT_TEXT_HEIGHT : 0;

    const tableHeight =
      (contentHeight - MAX_COUNT_HEIGHT - GAP * 2 - isMaxHeight) / 2;

    return toBN(height).gte(tableHeight) ? tableHeight : Number(height);
  }, [selectedFarms, isMaxFarmsCount, contentHeight]);

  return {
    tableHeightAllFarms,
    tableHeightSelectedFarms,
  };
};

export default useTablesHeight;
